<template>
  <div class="a-loading">
    <div class="a-loading__wrapper">
      <div class="a-loading__size">{{ displayed | ellipse }}</div>
      <div class="a-loading__content"
           :class="{ '--active': active }">{{ displayed | ellipse }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: ['message'],
  data() {
    return {
      displayed: undefined,
      active: false,
    };
  },
  filters: {
    ellipse(name = '') {
      return name.substring(0, 9) + (name.length > 10 ? '.' : name.substring(9, 10));
    },
  },
  watch: {
    message(message) {
      if (message) {
        this.displayed = message;
      }

      this.active = !!message;
    },
  },
};
</script>

<style lang="scss" scoped>
  .a-loading {
    text-align: center;
    font-size: 92px;
    font-family: TrioGrotesk, sans-serif;
    text-transform: uppercase;
    background: rgba(#fff, 0);
    transition: 0s all;

    &.--hide {
      display: none;
    }

    &:before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      height: 100%;
      width: 0;
    }

    &__wrapper {
      height: 1.75em;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      width: 100%;
    }

    &__size {
      line-height: 1.6em;
      opacity: 0;
    }

    &__content {
      line-height: 1.6em;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      bottom: -100%;
      transition: 0.9s all;
      text-align: center;

      &.--active {
        top: 0;
        bottom: 0;
        transition: 0.9s all;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Player/Loading.vue